import type {
  WarehouseItem,
  BinLocationItem,
  StockTransferItem,
  BatchSerialItem,
  ValuationLayer,
  ReceivingRow,
  CycleCountRow,
} from './types';

export const sampleWarehouses: WarehouseItem[] = [
  { id: '1', code: 'WH-CENTRAL', name: 'Central Distribution Hub', type: 'distribution', address: '100 Industrial Pkwy, Chicago, IL', is_active: true },
  { id: '2', code: 'WH-WEST', name: 'Pacific Fulfillment Center', type: 'distribution', address: '450 Marine Blvd, Reno, NV', is_active: true },
];

export const sampleTransfers: StockTransferItem[] = [
  { id: '1', transfer_number: 'TR-2026-001', source_warehouse_id: '1', dest_warehouse_id: '2', quantity: 25, status: 'IN_TRANSIT', created_at: new Date().toISOString() },
];

export const sampleBatches: BatchSerialItem[] = [
  { id: '1', sku_id: 'HL-OPT-100G', type: 'LOT', code: 'LOT-2026-X1', status: 'IN_STOCK', expiry_date: '2028-12-31' },
];

export const sampleValuationLayers: ValuationLayer[] = [
  { id: '1', sku: 'HL-OPT-100G', lot_code: 'LOT-2026-X1', receipt_date: '2026-01-15', unit_cost: 82.50, remaining_qty: 40, valuation_method: 'FIFO' },
  { id: '2', sku: 'HL-OPT-100G', lot_code: 'LOT-2026-X2', receipt_date: '2026-03-10', unit_cost: 85.00, remaining_qty: 25, valuation_method: 'FIFO' },
  { id: '3', sku: 'HL-SRV-2000', lot_code: 'SRV-BATCH-99', receipt_date: '2026-02-01', unit_cost: 1250.00, remaining_qty: 35, valuation_method: 'FEFO' },
];

export const sampleReceivingRows: ReceivingRow[] = [
  { id: '1', po_number: 'PO-2026-0041', supplier: 'Precision Microelectronics', received_qty: 50, quarantine_qty: 0, status: 'CLEARED' },
  { id: '2', po_number: 'PO-2026-0038', supplier: 'Apex Telecom Parts', received_qty: 100, quarantine_qty: 12, status: 'PENDING_QA' },
];

export const sampleCycleCountRows: CycleCountRow[] = [
  { id: '1', sku: 'HL-SRV-2000', location: 'WH-CENTRAL / Aisle A', expected_qty: 35, counted_qty: 35, status: 'RECONCILED' },
  { id: '2', sku: 'HL-OPT-100G', location: 'WH-CENTRAL / Aisle B', expected_qty: 65, counted_qty: 63, status: 'PENDING' },
  { id: '3', sku: 'HL-CHS-ALU', location: 'WH-WEST / Shelf 01', expected_qty: 60, counted_qty: 60, status: 'RECONCILED' },
];

export function adaptWarehouse(raw: any): WarehouseItem {
  return {
    id: raw?.id || `wh-${Math.random().toString(36).substring(2, 9)}`,
    code: raw?.code || 'WH-SITE',
    name: raw?.name || 'Warehouse Facility',
    type: raw?.type || 'distribution',
    address: raw?.address || 'Site Address',
    is_active: Boolean(raw?.is_active ?? true),
  };
}

export function adaptBinLocation(raw: any): BinLocationItem {
  return {
    id: raw?.id || `bin-${Math.random().toString(36).substring(2, 9)}`,
    warehouse_id: raw?.warehouse_id || 'wh-1',
    aisle: raw?.aisle || 'A',
    rack: raw?.rack || '01',
    shelf: raw?.shelf || '01',
    bin_code: raw?.bin_code || 'BIN-A01-01',
  };
}

export function adaptStockTransfer(raw: any): StockTransferItem {
  return {
    id: raw?.id || `tr-${Math.random().toString(36).substring(2, 9)}`,
    transfer_number: raw?.transfer_number || 'TR-2026',
    sku_id: raw?.sku_id,
    source_warehouse_id: raw?.source_warehouse_id || '1',
    dest_warehouse_id: raw?.dest_warehouse_id || '2',
    quantity: raw?.quantity ?? 0,
    status: raw?.status || 'PENDING',
    created_at: raw?.created_at || new Date().toISOString(),
  };
}

export function adaptBatchSerial(raw: any): BatchSerialItem {
  return {
    id: raw?.id || `bs-${Math.random().toString(36).substring(2, 9)}`,
    sku_id: raw?.sku_id || '',
    type: raw?.type || 'LOT',
    code: raw?.code || 'LOT-CODE',
    quantity: raw?.quantity,
    status: raw?.status || 'AVAILABLE',
    expiry_date: raw?.expiry_date,
    mfg_date: raw?.mfg_date,
  };
}
